import React from 'react'

const Astrologer_Wait_List = () => {
    return (
        <section className="gi-product-tab gi-products py-[30px] pb-[60px] max-[767px]:py-[30px] wow fadeInUp"
            data-wow-duration="2s">
            <div
                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">
                <div className="gi-tab-title w-full inline-flex justify-between px-[12px] max-[991px]:flex-col items-center">
                    <div className="gi-main-title">
                        <div className="section-title mb-[20px] pb-[20px] flex ">
                            <div className="section-detail">
                                <h2
                                    className="gi-title mb-[0] text-[25px] max-[991px]:text-[24px] max-[767px]:text-[22px] max-[575px]:text-[20px] font-semibold text-[#4b5966] relative inline p-[0]  leading-[1] font-Poppins tracking-[0.01rem]">
                                    Wait list</h2>
                            </div>
                        </div>
                    </div>
                    <div className="gi-pro-tab max-[991px]:mt-[-20px] max-[991px]:mb-[30px]">
                        <a href="#"
                            className="text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900">See
                            View All</a>
                    </div>
                </div>
                <div className="w-full mb-[-24px]">
                    <div
                        className="custome_jewellery grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-6 px-[15px]">
                        <div className="border rounded-lg p-4 bg-white">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h5 className="text-lg font-medium text-black">Repeat Indian</h5>
                                </div>
                                <div className="flex items-center gap-3">
                                    <a href="#"
                                        className="text-white hover:text-white border border-red-900 bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium text-white rounded-full text-sm px-5 py-2.5 text-center dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900">User
                                        Details</a>
                                </div>
                            </div>
                            <div className="shadow rounded-md p-4 mt-3">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <span className="text-sm text-gray-700">Order ID</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Name</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                    </div>

                                    <div>
                                        <span className="text-sm text-gray-700">Order Time</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">6 October 24, 3:55Am</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Duration</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">10 Minutes</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Token No.</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">5</h5>
                                    </div>

                                    <div>
                                        <span className="text-sm text-gray-700">Status</span>
                                        <h5 className="text-[14px] text-amber-400 font-medium">Waiting</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Type</span>
                                        <h5 className="text-[14px] text-red-600 font-medium">Call</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Order</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Omens User</h5>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <span
                                        className="mb-2 text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 inline-block">Start
                                        Offline Session</span>
                                </div>

                            </div>
                        </div>
                        <div className="border rounded-lg p-4 bg-white">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h5 className="text-lg font-medium text-black">Repeat Indian</h5>
                                </div>
                                <div className="flex items-center gap-3">
                                    <a href="#"
                                        className="text-white hover:text-white border border-red-900 bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium text-white rounded-full text-sm px-5 py-2.5 text-center dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900">User
                                        Details</a>
                                </div>
                            </div>
                            <div className="shadow rounded-md p-4 mt-3">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <span className="text-sm text-gray-700">Order ID</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Name</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                    </div>

                                    <div>
                                        <span className="text-sm text-gray-700">Order Time</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">6 October 24, 3:55Am</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Duration</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">10 Minutes</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Token No.</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">5</h5>
                                    </div>

                                    <div>
                                        <span className="text-sm text-gray-700">Status</span>
                                        <h5 className="text-[14px] text-amber-400 font-medium">Waiting</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Type</span>
                                        <h5 className="text-[14px] text-red-600 font-medium">Call</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Order</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Omens User</h5>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <span
                                        className="mb-2 text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 inline-block">Start
                                        Offline Session</span>
                                </div>

                            </div>
                        </div>
                        <div className="border rounded-lg p-4 bg-white">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h5 className="text-lg font-medium text-black">Repeat Indian</h5>
                                </div>
                                <div className="flex items-center gap-3">
                                    <a href="#"
                                        className="text-white hover:text-white border border-red-900 bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium text-white rounded-full text-sm px-5 py-2.5 text-center dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900">User
                                        Details</a>
                                </div>
                            </div>
                            <div className="shadow rounded-md p-4 mt-3">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <span className="text-sm text-gray-700">Order ID</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Name</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                    </div>

                                    <div>
                                        <span className="text-sm text-gray-700">Order Time</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">6 October 24, 3:55Am</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Duration</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">10 Minutes</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Token No.</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">5</h5>
                                    </div>

                                    <div>
                                        <span className="text-sm text-gray-700">Status</span>
                                        <h5 className="text-[14px] text-amber-400 font-medium">Waiting</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Type</span>
                                        <h5 className="text-[14px] text-red-600 font-medium">Call</h5>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-700">Order</span>
                                        <h5 className="text-[14px] text-[#0F1726] font-medium">Omens User</h5>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <span
                                        className="mb-2 text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 inline-block">Start
                                        Offline Session</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Astrologer_Wait_List